import React, { useState } from 'react';
import { EditIcon2 } from 'src/components/SvgIcons';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { PortfolioEditModal } from './PortfolioEditModal';
import { ExceededBudgetModal } from './ExceededBudgetModal';

interface PortfolioEditProps {
  title: string;
  value: string;
  linkId: string;
}

const PortfolioEdit: React.FC<PortfolioEditProps> = ({ title, value, linkId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        key={title}
        onClick={() => {
          setOpen(true);
        }}
        role="button"
      >
        <div className="field-title">{title}</div>
        <Flex
          gap={8}
          alignItems="center"
          sx={{
            margin: '2px 0 20px',
            '& .field-subtitle:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          <div
            className="field-subtitle no-margin"
            id={linkId}
            style={{
              width: '160px',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2
            }}
          >
            {value}
          </div>
          <EditIcon2
            style={{
              width: '16px',
              height: '16px'
            }}
          />
        </Flex>
      </div>
      <PortfolioEditModal open={open} setOpen={setOpen} />
      <ExceededBudgetModal />
    </>
  );
};

export default PortfolioEdit;
